<template>
    <div id="app">
        <!--博客首页显示-->
        <router-view>
        </router-view>

        <!--回到顶部的组件-->
        <go-top></go-top>
    </div>
</template>

<script>
    import GoTop from "@/components/gotop/GoTop"

    export default {
        name: 'App',
        components:
            {
                "go-top": GoTop,
            }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    /* 极简高级配色系统 */
    :root {
        --primary-dark: #1e293b;
        --primary-soft: #334155;
        --accent-warm: #d4a574;
        --accent-soft: #e8d5c4;
        --bg-primary: #fafbfc;
        --bg-secondary: #f1f5f9;
        --bg-card: #ffffff;
        --text-primary: #0f172a;
        --text-secondary: #475569;
        --text-tertiary: #94a3b8;
        --border-light: #e2e8f0;
        --shadow-soft: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.03);
        --shadow-card: 0 4px 20px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.02);
        --radius-sm: 8px;
        --radius-md: 12px;
        --radius-lg: 16px;
    }

    /* 全局背景 - 纯净浅灰 */
    body {
        position: relative;
        background-color: var(--bg-primary);
        font-weight: 400;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
        line-height: 1.6;
        color: var(--text-primary);
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    /* 链接样式 - 柔和优雅 */
    a {
        cursor: pointer;
        text-decoration: none;
        transition: all 0.25s ease;
        color: var(--text-secondary);
    }

    a:hover {
        color: var(--accent-warm);
    }

    html {
        height: 100%;
        scroll-behavior: smooth;
    }

    /* 滚动条美化 */
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    ::-webkit-scrollbar-track {
        background: var(--bg-secondary);
    }

    ::-webkit-scrollbar-thumb {
        background: var(--text-tertiary);
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: var(--text-secondary);
    }

    /* 科技风导航：点击后保持青色，覆盖 focus 时的白色 */
    .my-header .el-menu-item:focus,
    .my-header .el-menu-item:active {
        color: #00fff5 !important;
        background: rgba(0, 255, 245, 0.06) !important;
        border-bottom-color: #00fff5 !important;
        outline: none !important;
    }
    .my-header .el-menu-item:focus i,
    .my-header .el-menu-item:active i {
        color: #00fff5 !important;
    }
    .category-tag-page .el-tabs__item:focus,
    .category-tag-page .el-tabs__item:active {
        color: #00fff5 !important;
        outline: none !important;
    }
</style>
